import React, { useState } from 'react'
import {Container, makeStyles, Chip, Grid, List, Typography ,
} from '@material-ui/core';

import ListItem from '@material-ui/core/ListItem';
import {ListItemIcon, ListItemText, Divider} from '@material-ui/core';
import {AccountCircle, CallMerge, Edit, Email, Filter1, Phone, VpnKey } from '@material-ui/icons';
import { useStyles } from "../UserInformation/UserInformationStyle";
import Title from 'component/TitleWithIcon';
import InputPhone from './components/inputPhoneNumber';
import ChangePhoneNumber from './components/inputPhoneNumber';

export default function UserInformation (props) {
    const classes = useStyles()
    const [ open, setOpen ] = useState(false)

    const handleCloseModal =()=> setOpen(false)

    return (
        <Container maxWidth="md" className={classes.colorComponente}>        
            <Grid container >
                <Grid container item xs={12} direction="row" justify="center" alignItems="center">
                    <div className={classes.gridList} >
                    <Title title="Datos del Usuario" icon={"/assets/DatosUsuario.png"}/>    
                        <List className={classes.rootLista} dense>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}> <Filter1 /> </ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="CUI del DPI: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.code} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}> <AccountCircle /> </ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Nombre completo: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.name} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}> <Email /> </ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Correo electrónico: " />
                                <Chip className={classes.colorChip} label={props.DatosUsuario.email} />                                
                            </ListItem>
                            <ListItem>
                                <ListItemIcon className={classes.colorIcon}> <Phone/> </ListItemIcon>
                                <ListItemText className={classes.colorIcon} primary="Numero de teléfono: " />
                                <Chip 
                                    className={props.DatosUsuario.numero_telefonico ? classes.colorChip : classes.colorChipEmpty} 
                                    label={props.DatosUsuario.numero_telefonico}
                                    onDelete={()=>setOpen(true)}
                                    deleteIcon={<Edit className={props.DatosUsuario.numero_telefonico ? classes.icon : classes.bounceShake}/>}
                                />
                            </ListItem>
                        </List>
                        <Typography style={{textAlign: "center", fontSize: "small", padding: 10}}>* Si deseas actualizar el contacto telefónico, presiona el icono de lápiz.</Typography>
                    </div>
                </Grid>
            </Grid>
            <ChangePhoneNumber
                Set_current_user={props.Set_current_user}
                phoneNumber={props.DatosUsuario.numero_telefonico}
                userId={props.DatosUsuario.id}
                open={open}
                handleClose={handleCloseModal}
            />
        </Container>       
    )
}